export const rejectCategories = [
    { name: 'Select Reject Reason', id: -1 },
    { name: 'Official Id Issue', id: 1 },
    { name: 'Iimjobs.com', id: 2 },
    { name: 'Duplicate Posting', id: 3 },
    { name: 'Multiple Locations', id: 4 },
    { name: 'Others', id: 5 },
    { name: 'Not Relevant', id: 6 },
    { name: 'More Details', id: 7 },
    { name: 'Salary Offered', id: 8 },
    { name: 'engineeristic.com', id: 9 },
    { name: 'updazz.com', id: 10 },
    { name: 'No content', id: 11 },
    { name: 'Low Salary', id: 14 },
    { name: 'Low Salary v-a-v experience', id: 15 },    
    { name: 'ATS - Rejected due to unpublish action before publishing.', id: 16 },
]